import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

export type LicenseGateError = 'exceeded' | 'not-found' | 'unknown' | null;

export interface DeviceLicenseContextValue {
  licenseError: LicenseGateError;
  setLicenseError: (error: LicenseGateError) => void;
}

const DeviceLicenseContext = createContext<DeviceLicenseContextValue | null>(null);

export function DeviceLicenseProvider({ children }: { children: ReactNode }) {
  const [licenseError, setLicenseErrorState] = useState<LicenseGateError>(null);

  const setLicenseError = useCallback((error: LicenseGateError) => {
    setLicenseErrorState(error);
  }, []);

  return (
    <DeviceLicenseContext.Provider value={{ licenseError, setLicenseError }}>
      {children}
    </DeviceLicenseContext.Provider>
  );
}

export function useDeviceLicenseState(): DeviceLicenseContextValue {
  const ctx = useContext(DeviceLicenseContext);
  if (!ctx) throw new Error('useDeviceLicenseState must be used inside <DeviceLicenseProvider>');
  return ctx;
}
